<template>
  <div class="form-page_checkboxes">
    <div class="pl-disclaimer" v-if="isHardcodePL">
      <p>Przekazujemy Twoje dane naszemu partnerowi, Fincapital Sp. z o.o., aby mogli rozpatrzyć Twój wniosek.</p>
      <img :src="getImage()" />
    </div>
    <button v-else @click="checkAll" class="check-all">
      <img src="https://cdn.crezu.net/game_flow/src/assets/img/i-check.svg" alt="">
      <span>{{ field.field.selectAll || 'Zaznacz wszystkie' }}</span>
    </button>
    <Checkbox
      v-for="(value, index) in checkboxList"
      :key="index"
      :name="value.name"
      :show-error="value.showError"
      v-model="value.checked"
      @change="checkboxChanged(index, $event)"
    >
      <p v-html="value.label"></p>
    </Checkbox>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import InfoIcon from '../assetComponents/InfoIcon'
import Checkbox from '../assetComponents/Checkbox'

export default {
  name: 'Checkboxes',
  components: { InfoIcon, Checkbox },
  data () {
    return {
      checkboxList: [],
      hardcodePL: ['agreements_pl_kuki', 'agreements_pl_oros', 'agreements_pl_finbo']
    }
  },
  computed: {
    ...mapState({
      leadId: state => state.additionalParams.lead_id || localStorage.getItem('leadId') || localStorage.getItem('lead_id'),
      showInput: state => state.showInput,
      field: state => state.history[state.currentStep]
    }),
    isHardcodePL() {
      return !!this.hardcodePL.includes(this.field.name)
    }
  },
  mounted () {
    // get checkboxes
    this.$store.dispatch('getCheckboxes', this.leadId)
      .then((data) => {
        if (!data.agreements.length) { // error in getting checkboxes list -> go to process
          this.$store.commit('UPDATE_FIELD', { isValid: true, value: JSON.stringify({}) })
          this.$store.dispatch('nextStepPrepare', +1)
          return
        }
        this.checkboxList = data.agreements.map(x => {
          return {...x, ...{ checked: false, showError: false }}
        })

        const savedValue = this.field.value
        if (savedValue) {
          try {
            const parsed = JSON.parse(savedValue)
            this.checkboxList = this.checkboxList.map(x => {
              x.checked = parsed[x.name] || false
              return x
            })
          } catch (e) {}
        }

        this.$store.commit('UPDATE_FIELD', { isValid: this.validate(), value: this.formatValue() })
      })
      .catch((e) => {
        this.$store.commit('UPDATE_FIELD', { isValid: true, value: JSON.stringify({}) })
        this.$store.dispatch('nextStepPrepare', +1)
      })
  },
  watch: {
    showInput: function (val) {
      this.checkboxList = this.checkboxList.map(x => {
        if (x.required && !x.checked) x.showError = true
        return x
      })
    }
  },
  methods: {
    checkAll () {
      let value = false
      this.checkboxList.forEach(x => {
        if (!x.checked) value = true
      })
      this.checkboxList = this.checkboxList.map(x => {
        x.checked = value
        if (value) x.showError = false
        return x
      })
      if (value) window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: 'smooth' })
      this.$store.commit('UPDATE_FIELD', { isValid: this.validate(), value: this.formatValue() })
    },
    checkboxChanged (index, event) {
      if (event) this.checkboxList[index].showError = false
      this.checkboxList[index].checked = event
      this.$store.commit('UPDATE_FIELD', { isValid: this.validate(), value: this.formatValue() })
    },
    validate () {
      let result = true
      this.checkboxList.forEach(x => {
        if (x.required && !x.checked) result = false
      })
      return result
    },
    formatValue () {
      const result = {}
      this.checkboxList.forEach(x => { result[x.name] = x.checked })
      console.log('FORMATTED VALUE', result)
      return JSON.stringify(result)
    },
    getImage () {
      const lenderName = this.field.name.slice(14) // kuki, oros, finbo
      return `https://cdn.crezu.net/iframe/pic/${lenderName}_pl.png`
    }
  }
}
</script>

<style lang="scss">
  @import "../../assets/scss/checkboxes";
  .pl-disclaimer {
    p {
      font-size: 16px;
      color: var(--white, black);
      text-align: left;
    }

    img {
      margin: 40px auto 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/fields/Checkboxes.vue